import { ModuleTag } from "./moduleTag";
import { Link } from "react-router-dom";

export const VehicleTag = ({ vehicle, onRefresh }) => {
  const labelAction = vehicle?.id
    ? {
        path: `/dashboard/vehicles/${vehicle.id}`,
        action: false,
      }
    : null;

  return (
    <ModuleTag
      label="Vehicle"
      labelAction={labelAction}
      onAction={() => {}}
    >
      {vehicle?.displayTitle || vehicle?.number_plate || "Not selected"}
    </ModuleTag>
  );
};

